export const LANGUAGES = {
  de: 'Deutsch',
  en: 'Englisch',
  pl: 'Polnisch',
  uk: 'Ukrainisch',
  hu: 'Ungarisch',
};
